/**
 * bagStepper — the step rule behind the bag stepper in the customer detail's Stop strip.
 */

import type { BagOption } from '@/types';

/**
 * The bag count one whole bag above or below `count`. A half count goes to the nearest
 * whole bag in that direction, and anything under one bag is 0 (No Pickup). A step that
 * would leave `bagOptions` returns `count` unchanged, which is how the stepper knows to
 * disable that button.
 */
export function stepBags(count: number, direction: 'up' | 'down', bagOptions: BagOption[]): number {
  const target = direction === 'up' ? Math.floor(count) + 1 : Math.max(0, Math.ceil(count) - 1);
  return bagOptions.some(option => Number(option.id) === target) ? target : count;
}
